import React from 'react';
import { FDBox, FDStack, FDTitleText } from '@facet-wealth/design';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import ScenarioSelectionAssumptionSectionLineItems from './ScenarioSelectionAssumptionSectionLineItems';

const metaOverride = buildFacetDesignOverride()
  .nameOverride(['title'], {
    _component: () => FDTitleText,
  }, overrideReadOnly)
  .nameOverride(['lineItems'], {
    _component: () => ScenarioSelectionAssumptionSectionLineItems,
  }, overrideReadOnly);

const ScenarioSelectionAssumptionSection = ({ resource, searchTerm, showLineItems }) => {
  return (
    <FDStack direction={'column'} spacing={2} paddingY={2}>
      <FDBox paddingX={2}>
        <MetaControl attrName={'title'} metaOverrideSet={metaOverride} resource={resource} />
      </FDBox>
      <MetaControl attrName={'lineItems'} metaOverrideSet={metaOverride} resource={resource} CustomProps={{ searchTerm, alwaysShow: showLineItems }} />
    </FDStack>
  );
};

ScenarioSelectionAssumptionSection.defaultProps = {};

ScenarioSelectionAssumptionSection.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  searchTerm: PropTypes.string.isRequired,
  showLineItems: PropTypes.bool,
};

export default ScenarioSelectionAssumptionSection;
